import React, { useCallback } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';

import { SiteConfigManager, useApplicationState } from '@atlas/core';
import { staticRoutes } from '@atlas/routing';
import { Button, DefaultPopup, Label } from '@atlas/ui';

import ModalPortal from 'common/ModalPortal/ModalPortal';
import { useSignupPopup } from 'src/components/Auth/useSignUpPopup';

export const LuckyDayPopup = ({ handleCloseLuckyDayPopup }) => {
  const { pathname } = useLocation();
  const { authenticated } = useApplicationState();

  const { push: historyPush } = useHistory();

  const isEnableRegistration = SiteConfigManager.getConfig('config.config.enable_registration');
  const { openSignupPopup } = useSignupPopup();

  const signUpPopup = SiteConfigManager.getConfig('config.config.registration.showInPopup', false);

  const handleClose = useCallback(() => {
    historyPush(pathname);
    handleCloseLuckyDayPopup();
  }, [handleCloseLuckyDayPopup, historyPush, pathname]);

  if (authenticated) {
    handleCloseLuckyDayPopup();
  }
  return (
    <ModalPortal>
      <DefaultPopup className="popup-signup-delay" onClose={handleClose}>
        <div className="popup-signup-delay__content">
          <div className="sign-up-delay-text">
            <Label className="title-text" message="registration_popup_title" />
            <Label className="sub-title-text" message="registration_popup_description" />
          </div>
        </div>

        <div className="popup-signup-delay__footer">
          <Link to={staticRoutes.signin}>
            <Button block label="Sign in" size="big" type="secondary" />
          </Link>
          {isEnableRegistration && signUpPopup ? (
            <Button
              className="delay-signup-button"
              label="Sign up"
              onClick={openSignupPopup}
              size="big"
              type="primary"
            />
          ) : (
            <Link to={staticRoutes.signup}>
              <Button block label="Sign up" size="big" type="primary" />
            </Link>
          )}
        </div>
      </DefaultPopup>
    </ModalPortal>
  );
};
